import { render, staticRenderFns } from "./admin-setting-nav.vue?vue&type=template&id=799d0cce&scoped=true&"
import script from "./admin-setting-nav.vue?vue&type=script&lang=js&"
export * from "./admin-setting-nav.vue?vue&type=script&lang=js&"
import style0 from "./admin-setting-nav.vue?vue&type=style&index=0&id=799d0cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d0cce",
  null
  
)

export default component.exports